
    import {Component, Vue} from 'vue-property-decorator';
    import {IPage} from "@/js/page";
    import {auditApi} from "@/api/audit";
    import SetTableColumns from "@/components/SetTableColumns.vue"
    import {userApi} from "@/api/organization";

    @Component({
        name: "auditList",
        components: {SetTableColumns}
    })
    export default class Home extends Vue {
        title = "备案申请列表";
        listData = [];
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        listTotal = 0;
        listTotal0 = "";
        modeType = "0";
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        tabCol = [];
        showForm = false;
        form = {
            instrumentNames: "",  //器具名称
            departName: "",  //审核单位
            auditUserName: "", //审核人
            auditStartTime: "", //审核开始时间
            auditEndTime: "", //审核结束时间
            status: "",  //审核结果
            filingNo: "",  //备案表编号
            userName: "",  //发起人
            userMobile: "",  //联系电话
        } as any
        tableKey = 0;
        userData = {} as any;
        allSelected = [];

        created() {
            this.userData = this.$store.state.AuthedUser;
            const route = this.$route;
            const q = JSON.parse(JSON.stringify(route.query));
            if(q.modeType){
                this.modeType = q.modeType;
            }
            if(q.size){
                this.listParam.size = Number(q.size);
                this.listParam.current = Number(q.current);
            }
            this.getConfig();
        }
        activated(){
            if (this.$route.meta && !this.$route.meta.isBack) {
                this.showForm = false;
                this.reset();
            }else{
                this.list(this.modeType);
            }
        }
        getConfig() {
            userApi.getUserConfig({name: "auditPageSize"}).then(r => {
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    if (rData) {
                        this.listParam.size = Number(rData.config);
                    }
                    this.list("0");
                    if(this.modeType == "1"){
                        this.list("1");
                    }
                }
            })
        }
        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(()=>{
                let $table = this.$refs.table as HTMLFormElement;
                if($table){
                    $table.doLayout();
                }
                this.tableKey = Math.random();
            })
        }

        handleClick() {
            this.refresh();
        }

        indexMethod(index: any) {
            return (this.listParam.current - 1) * this.listParam.size + index + 1;
        }

        reset(){
            for(const f in this.form){
                this.form[f] = "";
            }
            this.refresh();
        }
        refresh() {
            this.listParam.current = 1;
            this.list();
        }

        list(modeType: string = this.modeType) {
            this.tableClearSelect();
            const route = this.$route;
            let q = JSON.parse(JSON.stringify(route.query));
            q = Object.assign(q,{modeType: this.modeType}, this.listParam);
            for (const key in q) {
                q[key] = String(q[key]);
            }
            const params = {
                ...this.listParam,
                ...this.form,
                submitType: modeType?modeType:this.modeType,
            }
            auditApi.list(params).then(r => {
                if(r.data.result == 0){
                    const rData = r.data.data;
                    if(this.modeType == modeType){
                        this.listData = rData.records;
                        this.listTotal = rData.total;
                    }
                    if(modeType == "0"){
                        this.listTotal0 = rData.total;
                    }
                    this.$nextTick(()=>{
                        let $table = this.$refs.table as HTMLFormElement;
                        if($table){
                            $table.doLayout();
                        }
                    })
                }
            })
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.refresh();
            userApi.updateUserConfig({name: "auditPageSize", config: val})
        }
        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.list();
        }
        add() {
            this.$router.push("/qj/audit/detail/0/0");
        }
        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }
        tableClearSelect(){
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
        }
        rightBtn(type: number) {
            const dataArr = this.allSelected as any;
            if (dataArr.length == 0) {
                this.$message.error("请先勾选");
                return;
            }
            if (dataArr.length > 1) {
                this.$message.error("只能勾选一条");
                return;
            }
            this.toDetail(dataArr[0].id, type);
        }

        //跳转详情
        toDetail(id: number, type: number) {
            this.$router.push("/qj/audit/detail/" + id + "/" + type);
        }
    }
